import { SPEED_FILTER_OPTIONS } from "../constants/filters";

import type {
	SearchInputProps,
	SpeedCheckboxProps,
	SpeedFiltersProps,
} from "../types";

export const SearchInput = ({ value, onChange }: SearchInputProps) => (
	<input
		className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-blue-500 focus:outline-none"
		onChange={(e) => onChange(e.target.value)}
		placeholder="Busque pela placa ou motorista"
		type="text"
		value={value}
	/>
);

export const SpeedCheckbox = ({
	option,
	isChecked,
	onToggle,
	count,
}: SpeedCheckboxProps) => (
	<label className="flex cursor-pointer items-center gap-2 rounded-md border border-[#D5D7DA] p-[5px]">
		<input
			checked={isChecked}
			className="h-4 w-4 rounded border-gray-300 accent-blue-600 focus:ring focus:ring-blue-500"
			onChange={onToggle}
			type="checkbox"
		/>
		<span className="font-medium text-sm">{option.label}</span>
		<span className="rounded bg-gray-200 px-1.5 font-medium text-sm">
			{count}
		</span>
	</label>
);

const getSpeedOptionCount = (
	optionId: number,
	movingCount: number,
	stoppedCount: number
): number => (optionId === 1 ? movingCount : stoppedCount);

export const SpeedFilters = ({
	speedFilter,
	setSpeedFilter,
	movingCount,
	stoppedCount,
}: SpeedFiltersProps) => {
	const handleSpeedToggle = (filterId: number) => {
		setSpeedFilter(speedFilter === filterId ? undefined : filterId);
	};

	return (
		<div className="flex gap-2">
			{SPEED_FILTER_OPTIONS.map((option) => (
				<SpeedCheckbox
					count={getSpeedOptionCount(option.id, movingCount, stoppedCount)}
					isChecked={speedFilter === option.id}
					key={option.id}
					onToggle={() => handleSpeedToggle(option.id)}
					option={option}
				/>
			))}
		</div>
	);
};
